/*
 * What an InlineEdit saves when the Member leaves it, kept apart from the component so the rule can
 * be checked without a browser.
 */

/**
 * The text to save from a finished edit, trimmed, or undefined when there is nothing to save: the
 * text is unchanged, or blank, which no name or title may be, so a cleared field puts the old text
 * back rather than asking the server to refuse it.
 */
export function settledDraft(draft: string, value: string) {
  const next = draft.trim()
  return next === "" || next === value ? undefined : next
}

/**
 * Text as one line: a title wraps on screen, but never holds a line break, so one pasted in
 * becomes a space.
 */
export function oneLine(text: string) {
  return text.replace(/[^\S\n]*\n\s*/g, " ")
}
